import moment from "moment";

const TIME_PARSE_FORMATS = ["HH:mm:ss", "HH:mm", "h:mm A", "hh:mm A"];

/** Normalize API / DB times to HH:mm for HTML type="time" inputs. */
export function normalizeTimeForInput(
  time: string | number | null | undefined
): string {
  if (time === null || time === undefined || String(time).trim() === "") {
    return "";
  }
  const parsed = moment(String(time), TIME_PARSE_FORMATS, true);
  return parsed.isValid() ? parsed.format("HH:mm") : "";
}
